<!------------------------------------------------------------------------------
 File: floating-button 
 Created by keni.
 with: IntelliJ IDEA
 Date: 29/08/2018
 Time: 13:56
------------------------------------------------------------------------------->
<template>
    <div :class="setButtonClass"
         class="animated pulse" :style="setButtonPosition"
         v-on:click="$emit('clicked')"
    >
        <a v-if="href!=null"
           :class="cls"
           :href="href"
        >
            <i v-if="material_icon" class="material-icons">{{icon}}</i>
            <i v-else :class="icon"></i>
        </a>
        <div v-else
             :class="[
                cls
                ,
                material_icon?'material-design':''
        ]">
            <i v-if="material_icon" class="material-icons">{{icon}}</i>
            <i v-else :class="icon"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "floating-button",
        components: {},

        props: {
            material_icon: {
                type: Boolean,
                default: null
            },
            icon: {
                type: String,
                default: 'fa fa-plus'
            },
            href: {
                type: String,
                default: null
            },
            button_color: {
                type: String,
                default: null
            },
            relative: {
                type: Boolean,
                default: null
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {

            if (this.button_color != null) {
                this.cls = `${this.button_color} ${this.cls}`;
            }
        },
        data() {
            return {
                cls: 'btn-floating btn-floating btn-floating--single waves-effect waves-light'
            }
        },
        methods: {
            setButtonClass() {
                if (this.relative != null) {
                    return 'position-absolute';
                } else {
                    return 'fixed-action-btn-est';
                }
            },
            setButtonPosition() {
                if (this.relative != null) {
                    return 'bottom: 45px; right: 24px;';
                }
                return null;
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/buttons/FloatingButton.vue?4ec95548